interface AssetType {
  id?: number;
  name?: string;
  companyId?: number;
}

export const newAssetType = (): AssetType => {
  return {};
};

export default AssetType;
